import { NavigationMenuId } from '../enums/navigationMenuId'
import { TransformItemsStructure } from './transformItemsStructure'

interface GetSpecialRouteItemArgs {
  currentPathname: string
  organizationUrl: string | undefined
  submenus: TransformItemsStructure[]
}

export const getSpecialRouteItem = ({ currentPathname, organizationUrl, submenus }: GetSpecialRouteItemArgs) => {
  const specialRoutes = {
    '/customer': NavigationMenuId.Clients,
    '/supplier': NavigationMenuId.Suppliers,
    '/bank_accounts': NavigationMenuId.Reconciliation,
  }
  const organizationPrefix = `/${organizationUrl}`

  if (currentPathname.startsWith(organizationPrefix)) {
    const pathnameWithoutOrganization = currentPathname.substring(organizationPrefix.length)

    for (const [route, itemId] of Object.entries(specialRoutes)) {
      if (pathnameWithoutOrganization.includes(route)) {
        return submenus.find((item) => item.id === itemId)
      }
    }
  }

  return null
}
